module.exports = __webpack_public_path__ + "static/media/aeronave.6673bfb0.glb";